<!-- 头部导航 -->
<template>
  <div>
    <!-- pc首页头部 -->
    <div class="header" id="header" v-if="chooseNav == '1'">
      <div class="container2">
        <div class="logo">
          <a href="/"><img src="static/picture/logo_1.png" /></a>
        </div>
        <ul class="nav">
          <li><a @click="linkPage(0)">LUARA</a></li>
          <li><a @click="linkPage(1)">HOC TIME</a></li>
          <li><a @click="linkPage(7)">THE FOLKTALE</a></li>
          <li><a @click="linkPage(2)">MAESOUL</a></li>
          <li><a @click="linkPage(3)">LEWA</a></li>
          <li><a @click="linkPage(4)">SLIM BEAUTY LABO</a></li>
          <li><a @click="linkPage(5)">About us</a></li>
          <li><a @click="linkPage(6)">COMING SOON</a></li>
        </ul>
      </div>
    </div>
    <div class="header bor_bot" id="header" v-if="chooseNav == '2'">
      <div class="cont840">
        <div class="logo">
          <a href="/"><img src="static/picture/logo_1.png" /></a>
        </div>
        <ul class="nav">
          <li><a @click="linkPages(0)">NEWS</a></li>
          <li><a @click="linkPages(1)">COMPANY PROFILE</a></li>
          <li><a @click="linkPages(2)">ABOUT LUARA</a></li>
          <li><a @click="linkPages(3)">ABOUT HOCTIME</a></li>
          <li><a @click="linkPages(4)">BRAND CONSULTANT</a></li>
          <li><a @click="linkPages(5)">CONTACT US</a></li>
          <!-- <li><a @click="linkPages(5)">APP</a></li> -->
          <li><a @click="linkPages(6)">TA</a></li>
          <li><a href="/">HOMEPAGE</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { apiLoginSubmitPhone, apiGetCodeNum, apiExitLogin, apiGetAgreement, apiGetPolicy } from '../api/login.js';
export default {
  name: 'HeaderNav',
  props: {
    chooseNav: {
      type: String, //传参类型
      default: '' //默认参数
    }
  },
  data() {
    return {
      login: 'false', //判断是否登录
      userInfo: [], //用户信息
      style: { backgroundColor: '' }, //头部样式
      styleLi: { color: '' }, //头部样式
      scrollTop: 0, //滑动距离
      selectBox: false, //已登录鼠标移动到右上角显示下拉框
      maskShow: false, //时候打开登录遮罩
      show: true, //是否显示倒计时
      count: 60, //倒计时
      checked: false, //复选框是否勾选
      phone: '', //手机号
      code: '', //验证码
      showAgreement: false, //协议弹窗时候打开
      cont: {} //协议内容
    };
  },
  created() {
    console.log(this.chooseNav);
  },
  mounted() {},
  methods: {
    //跳转链接
    linkPage(id) {
      if (id == 0) {
        this.$router.push({ path: '/LUARA', query: {} });
      }
      if (id == 1) {
        this.$router.push({ path: '/HOCTIME', query: {} });
      }
      if (id == 2) {
        this.$router.push({ path: '/MAESOUL', query: {} });
      }
      if (id == 3) {
        this.$router.push({ path: '/BRAND_UPGRADING', query: {} });
      }
      if (id == 4) {
        this.$router.push({ path: '/NEW_ARRIVIAL', query: {} });
      }
      if (id == 5) {
        this.$router.push({ path: '/Company', query: {} });
      }
      if (id == 6) {
        this.$router.push({ path: '/COMING_SOON', query: {} });
      }
      if (id == 7) {
        this.$router.push({ path: '/FOLKTALE', query: {} });
      }
    },
    linkPages(id) {
      if (id == 0) {
        this.$router.push({ path: '/News', query: {} });
      }
      if (id == 1) {
        this.$router.push({ path: '/Company', query: {} });
      }
      if (id == 2) {
        this.$router.push({ path: '/About', query: {} });
      }
      if (id == 3) {
        this.$router.push({ path: '/AboutHocTime', query: {} });
      }
      if (id == 4) {
        this.$router.push({ path: '/CONSULTANT', query: {} });
      }
      if (id == 5) {
        this.$router.push({ path: '/CONTACT', query: {} });
      }
      if (id == 6) {
        this.$router.push({ path: '/APP', query: {} });
      }
      if (id == 7) {
        this.$router.push({ path: '/TA', query: {} });
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 1110px) {
}
@media (min-width: 1110px) {
  .cont840 {
    width: 840px;
    margin: 0 auto;
  }
}
/*头部*/
.header {
  width: 100%;
}
.logo {
  margin: 35px auto 20px;
  text-align: center;
}
.logo img {
  max-width: 100%;
}

.nav {
  width: 100%;
  height: 46px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.nav li {
  padding: 0 30px;
  display: inline-block;
  text-align: center;
}
.nav li a {
  display: block;
  line-height: 42px;
  font-size: 16px;
  border-bottom: 4px solid #fff;
  color: #000000;
  font-family: Font_nav;
  text-transform: uppercase;
  position: relative;
  transition: all 0.3s ease-out 0s;
  -webkit-transition: all 0.3s ease-out 0s;
  -moz-transition: all 0.3s ease-out 0s;
  -o-transition: all 0.3s ease-out 0s;
  cursor: pointer;
}
.nav li:hover a,
.nav li.on a {
  border-bottom: 4px solid #000000;
}

.bor_bot {
  border-bottom: 1px solid #2e2e2e;
}
.cont840 .nav {
  height: 42px;
}
.cont840 .nav li a {
  /*width: 76px;*/
  line-height: 38px;
  font-size: 15px;
}
.cont840 .nav li:hover a,
.cont840 .nav li.on a {
  border-bottom: 4px solid #000000;
}
@media (min-width: 768px) {
  .nav li {
    padding: 0 15px;
  }
  .pc_img {
    display: none;
  }
  .wap_img {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: block;
  }
}

@media (min-width: 1110px) {
  .pc_img {
    display: block;
  }
  .wap_img {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: none;
  }
}
/*头部结束*/
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue